/* eslint-disable */
import React, { Component } from 'react';

import Master from './containers/Master'
import App from './containers/App'
import Fireadmin from './containers/Fireadmin'
import Firestoreadmin from './containers/Firestoreadmin'
import Push from './containers/Push'
import Config from   './config/app'
import { Router, Route,hashHistory} from 'react-router'

class Admin extends Component {

  //Prints the dynamic routes that we need for menu of type fireadmin
  getFireAdminRoutes(item){
    if(item.link==="fireadmin"){
      return (<Route currentLangData={this.props.currentLangData} path={"/fireadmin/"+item.path} component={Fireadmin}/>)
    }else{

    }
  }

  //Prints the dynamic routes that we need for menu of type fireadmin
  getFireAdminSubRoutes(item){
    if(item.link==="fireadmin"){
      return (<Route currentLangData={this.props.currentLangData} path={"/fireadmin/"+item.path+"/:sub"} component={Fireadmin}/>)
    }else{

    }
  }

  render() {
    return (
      <Router history={hashHistory}>
          <Route currentLangData={this.props.currentLangData} component={Master}>
            {/* make them children of `Master` */}
            <Route currentLangData={this.props.currentLangData} path={"/"} component={App}></Route>
            <Route currentLangData={this.props.currentLangData} path="/app" component={App}/>
            <Route currentLangData={this.props.currentLangData} path="/push" component={Push}/>
            <Route currentLangData={this.props.currentLangData} path="/fireadmin" loadedPath="/fireadmin/" hideHamburger={false} component={Fireadmin}/>
            <Route currentLangData={this.props.currentLangData} path="/fireadmin/:sub" loadedPath="/fireadmin/" hideHamburger={false} component={Fireadmin}/>
            <Route currentLangData={this.props.currentLangData} path="/firestoreadmin" component={Firestoreadmin}/>
            <Route currentLangData={this.props.currentLangData} path="/firestoreadmin/:sub" component={Firestoreadmin}/>
          </Route>
        </Router>
    );

   } 
  }


export default Admin;



// WEBPACK FOOTER //
// ./src/Admin.js